export class ZeroEtlJobsSort {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ZeroEtlJobsSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlJobsSort.attributeTypeMap;
    }
    constructor() {
    }
}
